/** Reprise inscription pro après OAuth Google (session courte). */
export const GOOGLE_SIGNUP_PENDING_KEY = 'signupGooglePending';

/** Destination post-OAuth pour un user sans profil pro. */
export const GOOGLE_SIGNUP_RESUME_PATH = '/signup-user';

export function markGoogleSignupPending(): void {
  try {
    sessionStorage.setItem(GOOGLE_SIGNUP_PENDING_KEY, '1');
    localStorage.setItem('justLoggedInWithGoogle', 'true');
  } catch {
    /* ignore quota */
  }
}

export function readGoogleSignupPending(): boolean {
  try {
    return sessionStorage.getItem(GOOGLE_SIGNUP_PENDING_KEY) === '1';
  } catch {
    return false;
  }
}

export function clearGoogleSignupPending(): void {
  try {
    sessionStorage.removeItem(GOOGLE_SIGNUP_PENDING_KEY);
    localStorage.removeItem('justLoggedInWithGoogle');
  } catch {
    /* ignore */
  }
}

/** Wizard signup-user à reprendre après connexion Google (pas encore de pro_id). */
export function isGoogleSignupResume(params: {
  isAuthenticated: boolean;
  user?: { pro_id?: number; google_id?: string; email?: string } | null;
  pending?: boolean;
}): boolean {
  if (!params.isAuthenticated || !params.user || params.user.pro_id) {
    return false;
  }
  if (params.user.google_id) {
    return true;
  }
  const pending = params.pending ?? readGoogleSignupPending();
  if (pending) {
    return true;
  }
  try {
    return localStorage.getItem('justLoggedInWithGoogle') === 'true';
  } catch {
    return false;
  }
}

/** Étape 3 du wizard : Google saute le mot de passe. */
export function isSignupStep2Valid(params: {
  isGoogleSignupFlow: boolean;
  password: string;
  confirmPassword: string;
}): boolean {
  if (params.isGoogleSignupFlow) {
    return true;
  }
  return (
    params.password.length >= 6 &&
    params.confirmPassword !== '' &&
    params.password === params.confirmPassword
  );
}
